import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useRef, useEffect } from 'react';
import { memoGeneric } from '@/js/libs/memo/index.ts';
import Icons from '../../../../Elements/Icons/index.js';
import { isEqualOptions } from '../../helpers.js';
import { OptionWrapper, CheckmarkWrapper } from './styled.js';
export const OptionSelect = memoGeneric(function OptionSelect({ option, selected, isFocused = false, onClick, optionSelected, formatOptionLabel, }) {
    const isSelected = useMemo(() => {
        if (!selected) {
            return false;
        }
        return optionSelected ? optionSelected(selected, option) : isEqualOptions(selected, option);
    }, [selected, option, optionSelected]);
    const label = useMemo(() => (formatOptionLabel ? formatOptionLabel(option) : option.label), [formatOptionLabel, option]);
    const ref = useRef(null);
    // Scroll into view when focused
    useEffect(() => {
        if (isFocused && ref.current) {
            ref.current.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
    }, [isFocused]);
    return (_jsxs(OptionWrapper, { onClick: onClick, $isSelected: isSelected, $isFocused: isFocused, ref: ref, "data-testid": 'option-label', "data-test-group": option.group, children: [_jsx("span", { children: label }), isSelected && (_jsx(CheckmarkWrapper, { children: _jsx(Icons.Checkmark, { size: 20 }) }))] }));
});
